// A screen must never just go white. React render errors are caught by
// CrashGuard in App.tsx; this covers the rest — errors thrown outside render
// (event handlers, timers, async), rejected promises nobody awaited, and a
// failure during boot itself, before React exists. Everything lands in the
// device log, so it reaches the hub and support without anyone reading a
// browser console.
import { logEvent } from "../services/devlog";

const brief = (v: unknown) => String((v as Error)?.message || v || "").slice(0, 200);

export function installCrashReporting(): void {
  if (typeof window === "undefined") return;
  window.addEventListener("error", (e: ErrorEvent) => {
    logEvent("js-error", { err: brief(e.error || e.message), at: `${e.filename || ""}:${e.lineno || 0}` });
  });
  window.addEventListener("unhandledrejection", (e: PromiseRejectionEvent) => {
    logEvent("js-rejection", { err: brief((e.reason as Error)?.stack || e.reason) });
  });
}

/** Last resort: boot threw, so there is no app to show a message. Paint one
 *  by hand rather than leave the screen blank. */
export function showBootFailure(err: unknown): void {
  try {
    logEvent("boot-failed", { err: brief(err) });
    const root = document.getElementById("root") || document.body;
    root.innerHTML = `
      <div style="min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;
                  background:#0f172a;color:#e2e8f0;font:16px/1.5 system-ui,sans-serif;padding:24px;text-align:center">
        <div style="font-size:40px">⚠️</div>
        <div style="font-weight:800;font-size:18px">This screen couldn't start</div>
        <div style="opacity:.7;font-size:13px;max-width:480px;word-break:break-word">${brief(err).replace(/[<>&]/g, "")}</div>
        <div style="opacity:.7;font-size:13px">Orders and settings are safe. Reload to carry on.</div>
        <button id="dp-reload" style="margin-top:8px;padding:12px 24px;border-radius:10px;border:0;background:#2563eb;
                color:#fff;font-size:15px;font-weight:700;cursor:pointer">Reload</button>
      </div>`;
    document.getElementById("dp-reload")?.addEventListener("click", () => location.reload());
  } catch {
    /* nothing left to try */
  }
}
